/**
 * 日程日历
 * created by lzy 2020.03.20
 */

'use strict';
angular.module('scheduleCalendarModule', []).directive('scheduleCalendar', ['$timeout', '$filter', '$compile', 'uiCalendarConfig', 'trsHttpService', 'messagePublishService',
    function($timeout, $filter, $compile, uiCalendarConfig, trsHttpService, messagePublishService) {
        return {
            restrict: 'E',
            repalace: true,
            scope: {
                userInfo: '=',
                selectDate: '=',
                callback: '&'
            },
            templateUrl: './dateReminder/directive/scheduleCalendar/scheduleCalendar.html',
            link: function($scope, iElement) {

                initStatus();
                initData();

                /**
                 * [initStatus description] 初始化状态
                 *
                 * @return  {[type]}  [return description]
                 */
                function initStatus() {
                    $scope.data = {
                        weekDay: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
                        today: $filter('date')(new Date(), 'yyyy-MM-dd'),
                        events: [],
                        params: {},
                        taps: [{
                            name: '全部',
                            type: ''
                        }, {
                            name: '新闻日历',
                            type: '4'
                        }, {
                            name: '日程提醒',
                            type: '1'
                        }, {
                            name: '任务',
                            type: '2'
                        }]
                    
                    };
                    $scope.status = {};
                    $scope.uiConfig = {
                        calendar: {
                            height: 352,
                            navLinks: true,
                            editable: false,
                            header: {
                                left: 'prev',
                                center: 'title',
                                right: 'next'
                            },
                            titleFormat: 'YYYY年M月',
                            firstDay: 1,
                            eventLimit: true, // 是否限制每个时间块显示的事件总数
                            views: {
                                month: {
                                    eventLimit: 2,
                                    eventLimitText: '项...',
                                    displayEventTime: true,
                                }
                            },

                            events: function(start, end, timezone, callback) {
                                var view = uiCalendarConfig.calendars.myCalendar.fullCalendar('getView');
                                var date = $filter('date')(view.intervalStart._d, 'yyyy-MM');
                                $scope.data.startDate = Date.parse(view.start._d);
                                $scope.data.endDate = Date.parse(view.end._d) - 24*60*60*1000;
                                getScheduleMonth(date);
                                addFestivalInfo($scope.data.startDate, $scope.data.endDate);
                            },

                            /**
                             * [dayClick description]点击日历中的每天
                             * @param  {[obj]} jsEvent     [description]获得当前点击天的具体信息，包括当前时间
                             * @return {[type]}             [description]null
                             */
                            dayClick: function(jsEvent) {
                                uiCalendarConfig.calendars.myCalendar.fullCalendar('gotoDate', $filter('date')(jsEvent._d, 'yyyy-MM'));
                                dayClick(jsEvent._d, this);
                            }
                        }
                    };
                }

                /**
                 * [initData description] 初始化数据
                 *
                 * @return  {[type]}  [return description]
                 */
                function initData() {
                    getDate(new Date());
                    loadDirective();
                    $timeout(function() {
                        $scope.data.currSelectedMonth = $filter('date')(new Date(), 'yyyy-MM');
                        $scope.callback()({
                            month: $scope.data.currSelectedMonth
                        });
                    })
                    messagePublishService.subscribe('createNewSchedule', function() {
                        uiCalendarConfig.calendars.myCalendar.fullCalendar('refetchEvents');
                    }, $scope);
                    messagePublishService.subscribe('calendarTarget', function() {
                        $timeout(function() {
                            goTarget();
                        })
                    }, $scope);
                }

                /**
                 * [goTarget description] 锚点
                 *
                 * @return  {[type]}   [return description]
                 */
                function goTarget() {
                    var docu = document.querySelector('#date' + $scope.data.selectDate);
                    if (docu) {
                        docu.scrollIntoView(true);
                    }
                }

                /**
                 * [getDate description] 获取日期
                 *
                 * @param   {[type]}  date  [date description] 日期对象
                 *
                 * @return  {[type]}        [return description]
                 */
                function getDate(date) {
                    $scope.selectDate = $scope.data.selectDate = $filter('date')(date, 'yyyy-MM-dd');
                    if (!$scope.data.date) {
                        $scope.data.date = date.getDate();
                        // $scope.data.year = date.getFullYear();
                        // $scope.data.month = date.getMonth() + 1;
                        // $scope.data.day = date.getDay();
                        $scope.data.yangDate = `${$scope.data.weekDay[date.getDay()]} ${date.getFullYear()}年${date.getMonth() + 1}月`;
                        var cTerm = lunar(date);
                        $scope.data.nongDate = `${cTerm.gzYear}(${cTerm.animal})年  ${cTerm.lMonth}月${cTerm.lDate}`;
                    }
                }

                /**
                 * [loadDirective description] 动态加载
                 * @return  {[type]}  [return description]
                 */
                function loadDirective() {
                    var uiCalendar =
                        '<div class="Almanac" ui-calendar="uiConfig.calendar" calendar="myCalendar" ng-model="data.events"></div>';
                    uiCalendar = $compile(uiCalendar)($scope);
                    iElement.find('calendar').append(uiCalendar);
                }

                /**
                 * [getScheduleMonth description] 获取月份具体日程
                 *
                 * @param   {[type]}  date  [date description] 日历选中月份
                 *
                 * @return  {[type]}        [return description]
                 */
                function getScheduleMonth(date) {
                    var params = {
                        serviceid: 'daily',
                        method: 'arrangedDates',
                        month: date,
                        tenantId: $scope.userInfo.TENANTID,
                        userId: $scope.userInfo.ID,
                        type: $scope.data.params.type
                    };
                    trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, 'get').then(function(data) {
                        var html = '<div class="tips"><span class="spot"></span></div>';
                        $('.fc-bg td[data-date]').find('.tips').remove();
                        for (var i = 0; i < data.datas.length; i++) {
                            $('.fc-bg td[data-date=' + data.datas[i] + ']').html(html);
                        }
                        $timeout(function() {
                            var that = $('.fc-bg td[data-date=' + $scope.data.selectDate + ']');
                            if ($scope.data.selectDate.indexOf(date) !== -1) {
                                dayClick(date, that, true);
                                var index = $('.Almanac').find('.fc-day.fc-today').index();
                                $('.Almanac').find('.fc-day.fc-today').parents('.fc-bg').next().find('tbody td').eq(index).addClass('event-tip');
                            } else {
                                $('.Almanac').find('.fc-today').removeClass('fc-today');
                            }
                        });
                    });
                }

                /**
                 * [addFestivalInfo description] 添加节假日信息
                 *
                 * @param  {[type]}  view   [view description]
                 * @param  {[type]}  date   [date description]
                 *
                 * @return  {[type]}   [return description]
                 */
                function addFestivalInfo(startDate, endDate) {
                    var cTerm = '';
                    var festival = '';
                    var params = {
                        serviceid: 'daily',
                        method: 'listAndGroupByTime',
                        timeDuration: $filter('date')(startDate, 'yyyy-MM-dd') + ',' + $filter('date')(endDate, 'yyyy-MM-dd'),
                        pageNum: 1,
                        pageSize: 100,
                        tenantId: $scope.userInfo.TENANTID,
                        userId: $scope.userInfo.ID,
                        type: 4
                    };
                    trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, 'get').then(function(data) {
                        while (startDate <= endDate) {
                            // modified by feifei.im 增加节气显示
                            cTerm = lunar(startDate);
                            startDate += 24*60*60*1000;
                            var _date = $filter('date')(cTerm.oDate, 'yyyy-MM-dd');
                            if (data.datas[_date]) {
                                festival = data.datas[_date][0].content;
                            } else if(cTerm.lDate === '初一') {
                                festival = cTerm.lMonth + '月';
                            } else {
                                festival = cTerm.lDate
                            }
                            var html = `<div title="${festival}" class="fc-festival">${festival}</div>`;
                            $('.fc-content-skeleton td[data-date=' + _date + '] .fc-festival').remove();
                            $('.fc-content-skeleton td[data-date=' + _date + ']').append(html);
                        }
                    });
                }

                /**
                 * [dayClick description] 出发日期点击事件
                 *
                 * @param   {[type]}  date  [date description]
                 * @param   {[type]}  that  [date description]
                 * @param   {[type]}  isReq  [date description]
                 *
                 * @return  {[type]}        [return description]
                 */
                function dayClick(date, that, isReq) {
                    that = that || this;
                    // $scope.data.yearMonthWeek = jsEvent._d.getFullYear() + '/' + $scope.params.month + '   ' + $scope.data.weekDay;
                    // $scope.data.today_Lunar = trsLunarDateService.getLunarDate(new Date($scope.status.curTime));
            
                    var index = $(that).index();
                    $(that).parents('.fc-day-grid').find('.fc-today').removeClass('fc-today');
                    // $('.Almanac').find('.fc-state-highlight').addClass('stateToday');
                    $(that).parents('.fc-row').find('.fc-day').eq(index).addClass('fc-today');
                    $(that).parents('.fc-row').find('.fc-day-number').eq(index).addClass('fc-today');
                    $('td.event-tip').removeClass('event-tip');
                    $(that).parents('.fc-bg').next().find('tbody td').eq(index).addClass('event-tip');
                    if (!isReq) {
                        getDate(date);
                        if ($scope.data.selectDate.indexOf($scope.data.currSelectedMonth) < 0) {
                            $scope.data.currSelectedMonth = $filter('date')(date, 'yyyy-MM');
                            $scope.callback()({
                                month: $scope.data.currSelectedMonth
                            });
                        } else {
                            goTarget()
                        }
                    }
                }

                /**
                 * [gotoToday description] 返回今天
                 *
                 * @return  {[type]}  [return description]
                 */
                $scope.gotoToday = function() {
                    uiCalendarConfig.calendars.myCalendar.fullCalendar('today');
                    var date = new Date();
                    var _date = $filter('date')(date, 'yyyy-MM-dd');
                    var that = $('.fc-bg td[data-date=' + _date + ']');
                    dayClick(date, that);
                };

                $scope.changeTap = function(value) {
                    $scope.data.params.type = value;
                    uiCalendarConfig.calendars.myCalendar.fullCalendar('refetchEvents');
                    $scope.callback()({
                        type: value
                    });
                };
            }
        };
    }
]);
